import { render, staticRenderFns } from "./info-card-mobile.vue?vue&type=template&id=8aaa434c&lang=pug&"
import script from "./info-card-mobile.vue?vue&type=script&lang=js&"
export * from "./info-card-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports